import { Accordion, Group, Stack, Text } from '@mantine/core';
import React, { useState } from 'react';
import useRetrieveChildDatasets from '@/hooks/api/datasets/useRetrieveChildDatasets.ts';
import CustomSpinner from '@/components/Spinner.tsx';
import DatasetSidebarItem from '@/pages/Result/components/DatasetSidebarItem.tsx';
import DatasetIcon from '@/components/DatasetIcon.tsx';
import { useHover } from '@mantine/hooks';
import { useViewDataset } from '@/hooks/useViewDataset.ts';
import { Run } from '@/types/runs.ts';
import { Dataset } from '@/types/datasets.ts';

type props = {
  run: Run;
  dataset: Dataset;
  addTab: (datasetId: string) => void;
};

const DirectoryDatasetSidebarItem = ({ run, dataset, addTab }: props) => {
  const { datasetId, setDatasetId } = useViewDataset();
  const [value, setValue] = useState<null | string>(datasetId === dataset.id ? datasetId : null);

  const { hovered, ref: hoverRef } = useHover();

  const { data: childDatasets, isPending: isLoading } = useRetrieveChildDatasets(
    value || undefined,
  );
  const childResults = childDatasets?.results ?? [];
  const hasChildDatasets = childResults.length > 0;

  return (
    <Accordion
      value={value}
      onChange={(newValue) => {
        setValue(newValue);
        setDatasetId(newValue || undefined);
      }}
      variant={'unstyled'}
      styles={{ label: { padding: 0 }, root: { padding: 0 } }}
    >
      <Accordion.Item value={dataset.id}>
        <Accordion.Control
          px={'xs'}
          h={'30px'}
          style={{ borderRadius: '5px', background: hovered ? '#F2F6F7' : 'transparent' }}
          ref={hoverRef}
        >
          <Group align={'center'} wrap={'nowrap'} gap={'xs'}>
            <DatasetIcon dataset={dataset} size={'16px'} />

            <Stack style={{ flex: 1, minWidth: 0 }}>
              <Text c={'#0F172A'} truncate={'end'} size={'12px'}>
                {dataset.name}
              </Text>
            </Stack>
          </Group>
        </Accordion.Control>
        <Accordion.Panel styles={{ content: { padding: 0 } }}>
          {isLoading && <CustomSpinner size={'xs'} />}

          <Stack gap={'2px'} ml={'14px'}>
            {hasChildDatasets ? (
              childResults.map((child) => (
                <DatasetSidebarItem run={run} dataset={child} key={child.id} addTab={addTab} />
              ))
            ) : childDatasets ? (
              <Text size="11px" c="dimmed" py="xs">
                No child datasets
              </Text>
            ) : null}
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default DirectoryDatasetSidebarItem;
